<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      width="500">
      <v-card>
        <v-card-title>
          Crear cuenta
        </v-card-title>
        <v-card-text>
          <v-form v-model="isValid" ref="createAccount">
            <v-row>
              <v-col>
                <v-text-field
                  rounded
                  outlined
                  dense
                  v-model="form.name"
                  :rules="rules.name"
                  label="Nombre"
                />
              </v-col>
              <v-col>
                <v-text-field
                  rounded
                  outlined
                  dense
                  v-model.number="form.startAmount"
                  :rules="rules.amount"
                  label="Saldo inicial"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            outlined
            small
            depressed
            @click="closeAccountDialog">
            {{ $t('ctas.close') }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            dark
            small
            depressed
            @click="createAccount">
            {{ $t('ctas.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        name: null,
        startAmount: 0
      },
      rules: {
        name: [v => !!v || `${this.$i18n.t('recipes.labels.name')} ${this.$i18n.t('messages.isRequired')}`],
        startAmount: [v => !!v || `Saldo inicial${this.$i18n.t('messages.isRequired')}`]
      }
    }
  },
  methods: {
    openDialog (account) {
      if (account) {
        this.form = { ...account }
      }
      this.isOpen = true
    },
    closeAccountDialog () {
      this.isOpen = false
      this.form = {
        name: null
      }
      this.$refs.createAccount.reset()
    },
    async createAccount () {
      this.$refs.createAccount.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          const payload = { ...this.form }
          if (payload._id) {
            await this.$api.put(`/v1/financial/unit-accounts/${payload._id}`, payload)
          } else {
            await this.$api.post(`/v1/financial/unit-accounts`, payload)
          }
          this.$emit('updated')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.closeAccountDialog()
      }
    }
  }
}
</script>
